// extracted by mini-css-extract-plugin
export var Access = "Access-module--Access--1hWpn";
export var Access__map = "Access-module--Access__map--6UVZG";
export var Access__list = "Access-module--Access__list--2roYA";